import { render, staticRenderFns } from "./addGroupModal.vue?vue&type=template&id=8fdeb250&scoped=true&"
import script from "./addGroupModal.vue?vue&type=script&lang=js&"
export * from "./addGroupModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8fdeb250",
  null
  
)

export default component.exports